import React, { forwardRef } from 'react';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import classNames from 'classnames';
import '@splidejs/splide/css/core';

import './ReactSplide.scss';

interface ReactSplide {
  children: Array<React.ReactElement>;
  options?: {};
  innerArrows?: boolean;
  onMoved?(): void;
}

const ReactSplide = ({ options = {}, children = [], innerArrows = false, onMoved = () => true }: ReactSplide, ref) => {
  const splideOptions = {
    pagination: false
  };

  return (<>
      <Splide ref={ref} options={{ ...splideOptions, ...options }} onMoved={onMoved} hasTrack={false}>
        <SplideTrack>
          { children?.map((file, i) => {
            return (
              <SplideSlide key={`key_${i}`}>
                {file}
              </SplideSlide>
            );
          })}
        </SplideTrack>
        <div className="splide__arrows">
          <button className={classNames(
            'splide__arrow splide__arrow--prev',
            {
              'splide__arrow--inner': innerArrows
            })}>
            <span className="dashicon dashicon-chevron-left"/>
          </button>
          <button className={classNames(
            'splide__arrow splide__arrow--next',
            {
              'splide__arrow--inner': innerArrows
            })}>
            <span className="dashicon dashicon-chevron-right"/>
          </button>
        </div>
      </Splide>
    </>
  );
};

export default forwardRef(ReactSplide);
